import Vue from 'vue'
import eventBus from '@/plugins/eventbus'
import {
  EVENT_PUSHER_AVAILABLE,
  EVENT_REALTIME_ECHO_REGISTERED,
  EVENT_ACCESS_TOKEN_UPDATED,
  EVENT_LOGOUT_AFTER,
  EVENT_PUSHER_EVENT_RECEIVED
} from '@/plugins/eventbus'
import Echo from "laravel-echo"
import store from '@/plugins/store'
import $common from '@/plugins/common'

Vue.prototype.$realtime = new Vue()
Vue.prototype.$realtime.echo = undefined;
Vue.prototype.$realtime.userChannel = undefined;

var gAccessToken = undefined

const USER_EVENTS_LISTEN_TO = [
  'ChatGroupCreated',
  'ChatGroupUserStateUpdated',
  'GameinstanceInvitationAvailable',
  'GameinstanceInvitationDeleted',
];

function updateEchoHeaders(echo, accessToken) {
  if (!echo) {
    console.log('Ignoring to set access token at echo. echo is not set')
    return;
  }
  if (accessToken) {
    echo.connector.pusher.config.auth.headers['Authorization'] = 'Bearer ' + accessToken;

    let userChannelName = "App.User." + store.state.profile.uid;
    if ($common.isDevEnv()) {
      console.log('Listening to user channel ' + userChannelName)
    }
  
    let privateUserChannel = Vue.prototype.$realtime.echo.private(userChannelName);
    Vue.prototype.$realtime.userChannel = privateUserChannel;
    privateUserChannel.notification((notification) => {
      console.log('Notification', notification.type, notification);
    });
    USER_EVENTS_LISTEN_TO.forEach((eventName) => {
      // console.log('Listening for event ' + eventName)
      privateUserChannel.listen(eventName, e => {
        let eventBusEvent = {
          type: eventName,
          event: e
        };
        if (!store.state.env.global.isProduction) {
          console.log(`Received pusher event ${eventName}. Emitting `, eventBusEvent)
        }
        eventBus.$emit(EVENT_PUSHER_EVENT_RECEIVED, eventBusEvent);
      });
    });
  }
  // console.log('Access token set at pusher auth header:', accessToken)
}

eventBus.$on(EVENT_LOGOUT_AFTER, () => {
  let echo = Vue.prototype.$realtime.echo;
  if (echo) {
    console.log('Disconnecting from all broadcasts')
    try {
      echo.disconnect();
    } catch (e) {
      console.log('Ignoring', e)
    }
    delete echo.connector.pusher.config.auth.headers['Authorization'];
  }
  Vue.prototype.$realtime.userChannel = undefined;
});

eventBus.$on(EVENT_PUSHER_AVAILABLE, (data) => {
  // console.log('Pusher app_key is now available', data);
  if (Vue.prototype.$realtime.echo) {
    console.log('Echo is already registered! TODO: unregister and register again if required');
  }
  Vue.prototype.$realtime.pusher = require('pusher-js');

  if ($common.isDevEnv()) {
    console.log('Init pusher')
  }
  Vue.prototype.$realtime.echo = new Echo({
    broadcaster: 'pusher',
    key: data.app_key,
    cluster: data.cluster ? data.cluser : 'eu',
    encrypted: true
  });
  updateEchoHeaders(Vue.prototype.$realtime.echo, gAccessToken);
  eventBus.$emit(EVENT_REALTIME_ECHO_REGISTERED, {});
});

eventBus.$on(EVENT_ACCESS_TOKEN_UPDATED, (accessToken) => {
  gAccessToken = accessToken;
  updateEchoHeaders(Vue.prototype.$realtime.echo, accessToken)
});

Vue.prototype.$realtime.whisperInUserChannel = function(eventName, data) {
  if (Vue.prototype.$realtime.userChannel === undefined) {
    console.log('WARN: Userchannel is currently not available. Could not send ' + eventName)
    return;
  }
  Vue.prototype.$realtime.userChannel.whisper(eventName, data);
}

Vue.prototype.$realtime.leaveChannel = function(channelName) {
  if ($common.isDevEnv()) {
    console.log('Leaving echo channel ' + channelName)
  }
  let echo = Vue.prototype.$realtime.echo;
  if (echo) {
    echo.leave(this.channelName);
  } else {
    console.log('echo is not available currently')
  }
  return echo;
};

export default Vue.prototype.$realtime
